/* eslint-disable @typescript-eslint/consistent-indexed-object-style , @typescript-eslint/consistent-type-assertions , @typescript-eslint/consistent-type-definitions , @typescript-eslint/no-invalid-void-type , @typescript-eslint/no-unnecessary-condition , @typescript-eslint/no-unsafe-assignment , antfu/top-level-function , @typescript-eslint/no-misused-spread */
/**
 * Generated by orval 🍺
 * Do not edit manually!
 * Forgejo API
 * This documentation describes the Forgejo API.
 * OpenAPI spec version: 14.0.0
 */
import { useMutation, useQuery } from "@tanstack/vue-query";
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType,
} from "@tanstack/vue-query";

import * as axios from "axios";
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";

import { computed, unref } from "vue";
import type { MaybeRef } from "vue";

/**
 * SearchResults results of a successful search
 */
export interface SearchResults {
  data?: Repository[];
  ok?: boolean;
}

/**
 * ObjectFormatName of the underlying git repository
 */
export type RepositoryObjectFormatName =
  (typeof RepositoryObjectFormatName)[keyof typeof RepositoryObjectFormatName];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RepositoryObjectFormatName = {
  sha1: "sha1",
  sha256: "sha256",
} as const;

/**
 * Repository represents a repository
 */
export interface Repository {
  allow_fast_forward_only_merge?: boolean;
  allow_merge_commits?: boolean;
  allow_rebase?: boolean;
  allow_rebase_explicit?: boolean;
  allow_rebase_update?: boolean;
  allow_squash_merge?: boolean;
  archived?: boolean;
  archived_at?: string;
  avatar_url?: string;
  clone_url?: string;
  created_at?: string;
  default_allow_maintainer_edit?: boolean;
  default_branch?: string;
  default_delete_branch_after_merge?: boolean;
  default_merge_style?: string;
  default_update_style?: string;
  description?: string;
  empty?: boolean;
  external_tracker?: ExternalTracker;
  external_wiki?: ExternalWiki;
  fork?: boolean;
  forks_count?: number;
  full_name?: string;
  globally_editable_wiki?: boolean;
  has_actions?: boolean;
  has_issues?: boolean;
  has_packages?: boolean;
  has_projects?: boolean;
  has_pull_requests?: boolean;
  has_releases?: boolean;
  has_wiki?: boolean;
  html_url?: string;
  id?: number;
  ignore_whitespace_conflicts?: boolean;
  internal?: boolean;
  internal_tracker?: InternalTracker;
  language?: string;
  languages_url?: string;
  link?: string;
  mirror?: boolean;
  mirror_interval?: string;
  mirror_updated?: string;
  name?: string;
  /** ObjectFormatName of the underlying git repository */
  object_format_name?: RepositoryObjectFormatName;
  open_issues_count?: number;
  open_pr_counter?: number;
  original_url?: string;
  owner?: User;
  parent?: Repository;
  permissions?: Permission;
  private?: boolean;
  release_counter?: number;
  repo_transfer?: RepoTransfer;
  size?: number;
  ssh_url?: string;
  stars_count?: number;
  template?: boolean;
  topics?: string[];
  updated_at?: string;
  url?: string;
  watchers_count?: number;
  website?: string;
  wiki_branch?: string;
}

/**
 * ExternalTracker represents settings for external tracker
 */
export interface ExternalTracker {
  /** External Issue Tracker URL Format. Use the placeholders {user}, {repo} and {index} for the username, repository name and issue index. */
  external_tracker_format?: string;
  /** External Issue Tracker issue regular expression */
  external_tracker_regexp_pattern?: string;
  /** External Issue Tracker Number Format, either `numeric`, `alphanumeric`, or `regexp` */
  external_tracker_style?: string;
  /** URL of external issue tracker. */
  external_tracker_url?: string;
}

/**
 * ExternalWiki represents setting for external wiki
 */
export interface ExternalWiki {
  /** URL of external wiki. */
  external_wiki_url?: string;
}

/**
 * InternalTracker represents settings for internal tracker
 */
export interface InternalTracker {
  /** Let only contributors track time (Built-in issue tracker) */
  allow_only_contributors_to_track_time?: boolean;
  /** Enable dependencies for issues and pull requests (Built-in issue tracker) */
  enable_issue_dependencies?: boolean;
  /** Enable time tracking (Built-in issue tracker) */
  enable_time_tracker?: boolean;
}

/**
 * User represents a user
 */
export interface User {
  /** Is user active */
  active?: boolean;
  /** URL to the user's avatar */
  avatar_url?: string;
  created?: string;
  /** the user's description */
  description?: string;
  email?: string;
  /** user counts */
  followers_count?: number;
  following_count?: number;
  /** the user's full name */
  full_name?: string;
  /** URL to the user's profile page */
  html_url?: string;
  /** the user's id */
  id?: number;
  /** Is the user an administrator */
  is_admin?: boolean;
  /** User locale */
  language?: string;
  last_login?: string;
  /** the user's location */
  location?: string;
  /** the user's username */
  login?: string;
  /** the user's authentication sign-in name. */
  login_name?: string;
  /** Is user login prohibited */
  prohibit_login?: boolean;
  /** the user's pronouns */
  pronouns?: string;
  /** Is user restricted */
  restricted?: boolean;
  /** The ID of the user's Authentication Source */
  source_id?: number;
  starred_repos_count?: number;
  /** User visibility level option: public, limited, private */
  visibility?: string;
  /** the user's website */
  website?: string;
}

/**
 * Permission represents a set of permissions
 */
export interface Permission {
  admin?: boolean;
  pull?: boolean;
  push?: boolean;
}

/**
 * RepoTransfer represents a pending repo transfer
 */
export interface RepoTransfer {
  doer?: User;
  recipient?: User;
  teams?: Team[];
}

export type TeamPermission =
  (typeof TeamPermission)[keyof typeof TeamPermission];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TeamPermission = {
  none: "none",
  read: "read",
  write: "write",
  admin: "admin",
  owner: "owner",
} as const;

export type TeamUnitsMap = { [key: string]: string };

/**
 * Team represents a team in an organization
 */
export interface Team {
  can_create_org_repo?: boolean;
  description?: string;
  id?: number;
  includes_all_repositories?: boolean;
  name?: string;
  organization?: Organization;
  permission?: TeamPermission;
  units?: string[];
  units_map?: TeamUnitsMap;
}

/**
 * Organization represents an organization
 */
export interface Organization {
  avatar_url?: string;
  description?: string;
  email?: string;
  full_name?: string;
  id?: number;
  location?: string;
  name?: string;
  repo_admin_change_team_access?: boolean;
  /** deprecated */
  username?: string;
  visibility?: string;
  website?: string;
}

export interface APIValidationError {
  message?: string;
  url?: string;
}

/**
 * Issue represents an issue in a repository
 */
export interface Issue {
  assets?: Attachment[];
  assignee?: User;
  assignees?: User[];
  body?: string;
  closed_at?: string;
  comments?: number;
  created_at?: string;
  due_date?: string;
  html_url?: string;
  id?: number;
  is_locked?: boolean;
  labels?: Label[];
  milestone?: Milestone;
  number?: number;
  original_author?: string;
  original_author_id?: number;
  pin_order?: number;
  pull_request?: PullRequestMeta;
  ref?: string;
  repository?: RepositoryMeta;
  state?: StateType;
  title?: string;
  updated_at?: string;
  url?: string;
  user?: User;
}

export type AttachmentType =
  (typeof AttachmentType)[keyof typeof AttachmentType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AttachmentType = {
  attachment: "attachment",
  external: "external",
} as const;

/**
 * Attachment a generic attachment
 */
export interface Attachment {
  browser_download_url?: string;
  created_at?: string;
  download_count?: number;
  id?: number;
  name?: string;
  size?: number;
  type?: AttachmentType;
  uuid?: string;
}

/**
 * Label a label to an issue or a pr
 */
export interface Label {
  color?: string;
  description?: string;
  exclusive?: boolean;
  id?: number;
  is_archived?: boolean;
  name?: string;
  url?: string;
}

/**
 * Milestone milestone is a collection of issues on one repository
 */
export interface Milestone {
  closed_at?: string;
  closed_issues?: number;
  created_at?: string;
  description?: string;
  due_on?: string;
  id?: number;
  open_issues?: number;
  state?: StateType;
  title?: string;
  updated_at?: string;
}

/**
 * StateType issue state type
 */
export type StateType = string;

/**
 * PullRequestMeta PR info if an issue is a PR
 */
export interface PullRequestMeta {
  draft?: boolean;
  html_url?: string;
  merged?: boolean;
  merged_at?: string;
}

/**
 * RepositoryMeta basic repository information
 */
export interface RepositoryMeta {
  full_name?: string;
  id?: number;
  name?: string;
  owner?: string;
}

export interface APINotFound {
  errors?: string[];
  message?: string;
  url?: string;
}

/**
 * CreateIssueOption options to create one issue
 */
export interface CreateIssueOption {
  /** deprecated */
  assignee?: string;
  assignees?: string[];
  body?: string;
  closed?: boolean;
  due_date?: string;
  /** list of label ids */
  labels?: number[];
  /** milestone id */
  milestone?: number;
  ref?: string;
  title: string;
}

export interface APIForbiddenError {
  message?: string;
  url?: string;
}

/**
 * APIError is an api error with a message
 */
export interface APIError {
  message?: string;
  url?: string;
}

export interface APIRepoArchivedError {
  message?: string;
  url?: string;
}

/**
 * Comment represents a comment on a commit or issue
 */
export interface Comment {
  assets?: Attachment[];
  body?: string;
  created_at?: string;
  html_url?: string;
  id?: number;
  issue_url?: string;
  original_author?: string;
  original_author_id?: number;
  pull_request_url?: string;
  updated_at?: string;
  user?: User;
}

export interface APIInternalServerError {
  message?: string;
  url?: string;
}

/**
 * EditIssueCommentOption options for editing a comment
 */
export interface EditIssueCommentOption {
  body: string;
  updated_at?: string;
}

/**
 * EditIssueOption options for editing an issue
 */
export interface EditIssueOption {
  /** deprecated */
  assignee?: string;
  assignees?: string[];
  body?: string;
  due_date?: string;
  milestone?: number;
  ref?: string;
  state?: string;
  title?: string;
  unset_due_date?: boolean;
  updated_at?: string;
}

/**
 * CreateIssueCommentOption options for creating a comment on an issue
 */
export interface CreateIssueCommentOption {
  body: string;
  updated_at?: string;
}

/**
 * IssueLabelsOption a collection of labels
 */
export interface IssueLabelsOption {
  /** Labels can be a list of integers representing label IDs
or a list of strings representing label names */
  labels?: unknown[];
  updated_at?: string;
}

/**
 * DeleteLabelOption options for deleting a label
 */
export interface DeleteLabelsOption {
  updated_at?: string;
}

/**
 * TimelineComment represents a timeline comment (comment of any type) on a commit or issue
 */
export interface TimelineComment {
  assignee?: User;
  assignee_team?: Team;
  body?: string;
  created_at?: string;
  dependent_issue?: Issue;
  html_url?: string;
  id?: number;
  issue_url?: string;
  label?: Label;
  milestone?: Milestone;
  new_ref?: string;
  new_title?: string;
  old_milestone?: Milestone;
  old_project_id?: number;
  old_ref?: string;
  old_title?: string;
  project_id?: number;
  pull_request_url?: string;
  ref_action?: string;
  ref_comment?: Comment;
  /** commit SHA where issue/PR was referenced */
  ref_commit_sha?: string;
  ref_issue?: Issue;
  /** whether the assignees were removed or added */
  removed_assignee?: boolean;
  resolve_doer?: User;
  review_id?: number;
  tracked_time?: TrackedTime;
  type?: string;
  updated_at?: string;
  user?: User;
}

/**
 * TrackedTime worked time for an issue / pr
 */
export interface TrackedTime {
  created?: string;
  id?: number;
  issue?: Issue;
  /** deprecated (only for backwards compatibility) */
  issue_id?: number;
  /** Time in seconds */
  time?: number;
  /** deprecated (only for backwards compatibility) */
  user_id?: number;
  user_name?: string;
}

/**
 * CreateLabelOption options for creating a label
 */
export interface CreateLabelOption {
  color: string;
  description?: string;
  exclusive?: boolean;
  is_archived?: boolean;
  name: string;
}

export interface APIUnauthorizedError {
  message?: string;
  url?: string;
}

export interface AccessToken {
  id?: number;
  name?: string;
  scopes?: string[];
  sha1?: string;
  token_last_eight?: string;
}

/**
 * CreateAccessTokenOption options when create access token
 */
export interface CreateAccessTokenOption {
  name: string;
  scopes?: string[];
}

/**
 * SearchResults
 */
export type SearchResultsResponse = SearchResults;

/**
 * APIValidationError is error format response related to input validation
 */
export type ValidationErrorResponse = APIValidationError;

/**
 * IssueList
 */
export type IssueListResponse = Issue[];

/**
 * APINotFound is a not found error response
 */
export type NotFoundResponse = APINotFound;

/**
 * Issue
 */
export type IssueResponse = Issue;

/**
 * APIForbiddenError is a forbidden error response
 */
export type ForbiddenResponse = APIForbiddenError;

/**
 * APIError is error format response
 */
export type ErrorResponse = APIError;

/**
 * APIRepoArchivedError is an error that is raised when an archived repo should be modified
 */
export type RepoArchivedErrorResponse = APIRepoArchivedError;

/**
 * Comment
 */
export type CommentResponse = Comment;

/**
 * APIEmpty is an empty response
 */
export type EmptyResponse = void;

/**
 * APIInternalServerError is an error that is raised when an internal server error occurs
 */
export type InternalServerErrorResponse = APIInternalServerError;

/**
 * AttachmentList
 */
export type AttachmentListResponse = Attachment[];

/**
 * Attachment
 */
export type AttachmentResponse = Attachment;

/**
 * QuotaExceeded
 */
export type QuotaExceededResponse = void;

/**
 * CommentList
 */
export type CommentListResponse = Comment[];

/**
 * LabelList
 */
export type LabelListResponse = Label[];

/**
 * TimelineList
 */
export type TimelineListResponse = TimelineComment[];

/**
 * Label
 */
export type LabelResponse = Label;

/**
 * User
 */
export type UserResponse = User;

/**
 * APIUnauthorizedError is a unauthorized error response
 */
export type UnauthorizedResponse = APIUnauthorizedError;

/**
 * AccessTokenList represents a list of API access token.
 */
export type AccessTokenListResponse = AccessToken[];

/**
 * AccessToken represents an API access token.
 */
export type AccessTokenResponse = AccessToken;

export type IssueLabelsOptionBody = IssueLabelsOption;

export type RepoSearchParams = {
  /**
   * keyword
   */
  q?: string;
  /**
   * Limit search to repositories with keyword as topic
   */
  topic?: boolean;
  /**
   * include search of keyword within repository description
   */
  includeDesc?: boolean;
  /**
   * search only for repos that the user with the given id owns or contributes to
   */
  uid?: number;
  /**
   * repo owner to prioritize in the results
   */
  priority_owner_id?: number;
  /**
   * search only for repos that belong to the given team id
   */
  team_id?: number;
  /**
   * search only for repos that the user with the given id has starred
   */
  starredBy?: number;
  /**
   * include private repositories this user has access to (defaults to true)
   */
  private?: boolean;
  /**
   * show only public, private or all repositories (defaults to all)
   */
  is_private?: boolean;
  /**
   * include template repositories this user has access to (defaults to true)
   */
  template?: boolean;
  /**
   * show only archived, non-archived or all repositories (defaults to all)
   */
  archived?: boolean;
  /**
   * type of repository to search for. Supported values are "fork", "source", "mirror" and "collaborative"
   */
  mode?: string;
  /**
   * if `uid` is given, search only for repos that the user owns
   */
  exclusive?: boolean;
  /**
   * sort repos by attribute. Supported values are "alpha", "created", "updated", "size", "git_size", "lfs_size", "stars", "forks" and "id". Default is "alpha"
   */
  sort?: RepoSearchSort;
  /**
   * sort order, either "asc" (ascending) or "desc" (descending). Default is "asc", ignored if "sort" is not specified.
   */
  order?: RepoSearchOrder;
  /**
   * page number of results to return (1-based)
   */
  page?: number;
  /**
   * page size of results
   */
  limit?: number;
};

export type RepoSearchSort =
  (typeof RepoSearchSort)[keyof typeof RepoSearchSort];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RepoSearchSort = {
  alpha: "alpha",
  created: "created",
  updated: "updated",
  size: "size",
  git_size: "git_size",
  lfs_size: "lfs_size",
  id: "id",
  stars: "stars",
  forks: "forks",
} as const;

export type RepoSearchOrder =
  (typeof RepoSearchOrder)[keyof typeof RepoSearchOrder];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RepoSearchOrder = {
  asc: "asc",
  desc: "desc",
} as const;

export type IssueListIssuesParams = {
  /**
   * whether issue is open or closed
   */
  state?: IssueListIssuesState;
  /**
   * comma separated list of labels. Fetch only issues that have any of this labels. Non existent labels are discarded
   */
  labels?: string;
  /**
   * search string
   */
  q?: string;
  /**
   * filter by type (issues / pulls) if set
   */
  type?: IssueListIssuesType;
  /**
   * comma separated list of milestone names or ids. It uses names and fall back to ids. Fetch only issues that have any of this milestones. Non existent milestones are discarded
   */
  milestones?: string;
  /**
   * Only show items updated after the given time. This is a timestamp in RFC 3339 format
   */
  since?: string;
  /**
   * Only show items updated before the given time. This is a timestamp in RFC 3339 format
   */
  before?: string;
  /**
   * Only show items which were created by the given user
   */
  created_by?: string;
  /**
   * Only show items for which the given user is assigned
   */
  assigned_by?: string;
  /**
   * Only show items in which the given user was mentioned
   */
  mentioned_by?: string;
  /**
   * page number of results to return (1-based)
   */
  page?: number;
  /**
   * page size of results
   */
  limit?: number;
  /**
   * Type of sort
   */
  sort?: IssueListIssuesSort;
};

export type IssueListIssuesState =
  (typeof IssueListIssuesState)[keyof typeof IssueListIssuesState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const IssueListIssuesState = {
  closed: "closed",
  open: "open",
  all: "all",
} as const;

export type IssueListIssuesType =
  (typeof IssueListIssuesType)[keyof typeof IssueListIssuesType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const IssueListIssuesType = {
  issues: "issues",
  pulls: "pulls",
} as const;

export type IssueListIssuesSort =
  (typeof IssueListIssuesSort)[keyof typeof IssueListIssuesSort];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const IssueListIssuesSort = {
  relevance: "relevance",
  latest: "latest",
  oldest: "oldest",
  recentupdate: "recentupdate",
  leastupdate: "leastupdate",
  mostcomment: "mostcomment",
  leastcomment: "leastcomment",
  nearduedate: "nearduedate",
  farduedate: "farduedate",
} as const;

export type IssueCreateIssueCommentAttachmentParams = {
  /**
   * name of the attachment
   */
  name?: string;
  /**
   * time of the attachment's creation. This is a timestamp in RFC 3339 format
   */
  updated_at?: string;
};

export type IssueCreateIssueCommentAttachmentBody = {
  /** attachment to upload */
  attachment: Blob;
};

export type IssueGetCommentsParams = {
  /**
   * if provided, only comments updated since the specified time are returned.
   */
  since?: string;
  /**
   * if provided, only comments updated before the provided time are returned.
   */
  before?: string;
};

export type IssueGetCommentsAndTimelineParams = {
  /**
   * if provided, only comments updated since the specified time are returned.
   */
  since?: string;
  /**
   * page number of results to return (1-based)
   */
  page?: number;
  /**
   * page size of results
   */
  limit?: number;
  /**
   * if provided, only comments updated before the provided time are returned.
   */
  before?: string;
};

export type IssueListLabelsParams = {
  /**
   * Specifies the sorting method: mostissues, leastissues, or reversealphabetically.
   */
  sort?: IssueListLabelsSort;
  /**
   * page number of results to return (1-based)
   */
  page?: number;
  /**
   * page size of results
   */
  limit?: number;
};

export type IssueListLabelsSort =
  (typeof IssueListLabelsSort)[keyof typeof IssueListLabelsSort];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const IssueListLabelsSort = {
  mostissues: "mostissues",
  leastissues: "leastissues",
  reversealphabetically: "reversealphabetically",
} as const;

export type UserGetTokensParams = {
  /**
   * page number of results to return (1-based)
   */
  page?: number;
  /**
   * page size of results
   */
  limit?: number;
};

/**
 * @summary Search for repositories
 */
export const repoSearch = (
  params?: MaybeRef<RepoSearchParams>,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SearchResultsResponse>> => {
  params = unref(params);

  return axios.default.get(`/repos/search`, {
    ...options,
    params: { ...unref(params), ...options?.params },
  });
};

export const getRepoSearchQueryKey = (params?: MaybeRef<RepoSearchParams>) => {
  return ["repos", "search", ...(params ? [params] : [])] as const;
};

export const getRepoSearchQueryOptions = <
  TData = Awaited<ReturnType<typeof repoSearch>>,
  TError = AxiosError<ValidationErrorResponse>,
>(
  params?: MaybeRef<RepoSearchParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof repoSearch>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = getRepoSearchQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof repoSearch>>> = ({
    signal,
  }) => repoSearch(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof repoSearch>>,
    TError,
    TData
  >;
};

export type RepoSearchQueryResult = NonNullable<
  Awaited<ReturnType<typeof repoSearch>>
>;
export type RepoSearchQueryError = AxiosError<ValidationErrorResponse>;

/**
 * @summary Search for repositories
 */

export function useRepoSearch<
  TData = Awaited<ReturnType<typeof repoSearch>>,
  TError = AxiosError<ValidationErrorResponse>,
>(
  params?: MaybeRef<RepoSearchParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof repoSearch>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getRepoSearchQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData>;

  return query;
}

/**
 * @summary List a repository's issues
 */
export const issueListIssues = (
  owner: MaybeRef<string>,
  repo: MaybeRef<string>,
  params?: MaybeRef<IssueListIssuesParams>,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<IssueListResponse>> => {
  owner = unref(owner);
  repo = unref(repo);
  params = unref(params);

  return axios.default.get(`/repos/${owner}/${repo}/issues`, {
    ...options,
    params: { ...unref(params), ...options?.params },
  });
};

export const getIssueListIssuesQueryKey = (
  owner?: MaybeRef<string>,
  repo?: MaybeRef<string>,
  params?: MaybeRef<IssueListIssuesParams>,
) => {
  return ["repos", owner, repo, "issues", ...(params ? [params] : [])] as const;
};

export const getIssueListIssuesQueryOptions = <
  TData = Awaited<ReturnType<typeof issueListIssues>>,
  TError = AxiosError<NotFoundResponse>,
>(
  owner: MaybeRef<string>,
  repo: MaybeRef<string>,
  params?: MaybeRef<IssueListIssuesParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof issueListIssues>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = getIssueListIssuesQueryKey(owner, repo, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof issueListIssues>>> = ({
    signal,
  }) => issueListIssues(owner, repo, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!(unref(owner) && unref(repo))),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof issueListIssues>>,
    TError,
    TData
  >;
};

export type IssueListIssuesQueryResult = NonNullable<
  Awaited<ReturnType<typeof issueListIssues>>
>;
export type IssueListIssuesQueryError = AxiosError<NotFoundResponse>;

/**
 * @summary List a repository's issues
 */

export function useIssueListIssues<
  TData = Awaited<ReturnType<typeof issueListIssues>>,
  TError = AxiosError<NotFoundResponse>,
>(
  owner: MaybeRef<string>,
  repo: MaybeRef<string>,
  params?: MaybeRef<IssueListIssuesParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof issueListIssues>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getIssueListIssuesQueryOptions(
    owner,
    repo,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData>;

  return query;
}

/**
 * @summary Create an issue. If using deadline only the date will be taken into account, and time of day ignored.
 */
export const issueCreateIssue = (
  owner: MaybeRef<string>,
  repo: MaybeRef<string>,
  createIssueOption: MaybeRef<CreateIssueOption>,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<IssueResponse>> => {
  owner = unref(owner);
  repo = unref(repo);
  createIssueOption = unref(createIssueOption);

  return axios.default.post(
    `/repos/${owner}/${repo}/issues`,
    createIssueOption,
    options,
  );
};

export const getIssueCreateIssueMutationOptions = <
  TError = AxiosError<
    | ForbiddenResponse
    | NotFoundResponse
    | ErrorResponse
    | ValidationErrorResponse
    | RepoArchivedErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof issueCreateIssue>>,
    TError,
    { owner: string; repo: string; data: CreateIssueOption },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof issueCreateIssue>>,
  TError,
  { owner: string; repo: string; data: CreateIssueOption },
  TContext
> => {
  const mutationKey = ["issueCreateIssue"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof issueCreateIssue>>,
    { owner: string; repo: string; data: CreateIssueOption }
  > = (props) => {
    const { owner, repo, data } = props ?? {};

    return issueCreateIssue(owner, repo, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type IssueCreateIssueMutationResult = NonNullable<
  Awaited<ReturnType<typeof issueCreateIssue>>
>;
export type IssueCreateIssueMutationBody = CreateIssueOption;
export type IssueCreateIssueMutationError = AxiosError<
  | ForbiddenResponse
  | NotFoundResponse
  | ErrorResponse
  | ValidationErrorResponse
  | RepoArchivedErrorResponse
>;

/**
 * @summary Create an issue. If using deadline only the date will be taken into account, and time of day ignored.
 */
export const useIssueCreateIssue = <
  TError = AxiosError<
    | ForbiddenResponse
    | NotFoundResponse
    | ErrorResponse
    | ValidationErrorResponse
    | RepoArchivedErrorResponse
  >,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof issueCreateIssue>>,
      TError,
      { owner: string; repo: string; data: CreateIssueOption },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof issueCreateIssue>>,
  TError,
  { owner: string; repo: string; data: CreateIssueOption },
  TContext
> => {
  const mutationOptions = getIssueCreateIssueMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Get a comment
 */
export const issueGetComment = (
  owner: MaybeRef<string>,
  repo: MaybeRef<string>,
  id: MaybeRef<number>,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<CommentResponse | EmptyResponse>> => {
  owner = unref(owner);
  repo = unref(repo);
  id = unref(id);

  return axios.default.get(
    `/repos/${owner}/${repo}/issues/comments/${id}`,
    options,
  );
};

export const getIssueGetCommentQueryKey = (
  owner?: MaybeRef<string>,
  repo?: MaybeRef<string>,
  id?: MaybeRef<number>,
) => {
  return ["repos", owner, repo, "issues", "comments", id] as const;
};

export const getIssueGetCommentQueryOptions = <
  TData = Awaited<ReturnType<typeof issueGetComment>>,
  TError = AxiosError<
    ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse
  >,
>(
  owner: MaybeRef<string>,
  repo: MaybeRef<string>,
  id: MaybeRef<number>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof issueGetComment>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = getIssueGetCommentQueryKey(owner, repo, id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof issueGetComment>>> = ({
    signal,
  }) => issueGetComment(owner, repo, id, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!(unref(owner) && unref(repo) && unref(id))),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof issueGetComment>>,
    TError,
    TData
  >;
};

export type IssueGetCommentQueryResult = NonNullable<
  Awaited<ReturnType<typeof issueGetComment>>
>;
export type IssueGetCommentQueryError = AxiosError<
  ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse
>;

/**
 * @summary Get a comment
 */

export function useIssueGetComment<
  TData = Awaited<ReturnType<typeof issueGetComment>>,
  TError = AxiosError<
    ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse
  >,
>(
  owner: MaybeRef<string>,
  repo: MaybeRef<string>,
  id: MaybeRef<number>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof issueGetComment>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getIssueGetCommentQueryOptions(owner, repo, id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData>;

  return query;
}

/**
 * @summary Delete a comment
 */
export const issueDeleteComment = (
  owner: MaybeRef<string>,
  repo: MaybeRef<string>,
  id: MaybeRef<number>,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<EmptyResponse>> => {
  owner = unref(owner);
  repo = unref(repo);
  id = unref(id);

  return axios.default.delete(
    `/repos/${owner}/${repo}/issues/comments/${id}`,
    options,
  );
};

export const getIssueDeleteCommentMutationOptions = <
  TError = AxiosError<ForbiddenResponse | InternalServerErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof issueDeleteComment>>,
    TError,
    { owner: string; repo: string; id: number },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof issueDeleteComment>>,
  TError,
  { owner: string; repo: string; id: number },
  TContext
> => {
  const mutationKey = ["issueDeleteComment"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof issueDeleteComment>>,
    { owner: string; repo: string; id: number }
  > = (props) => {
    const { owner, repo, id } = props ?? {};

    return issueDeleteComment(owner, repo, id, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type IssueDeleteCommentMutationResult = NonNullable<
  Awaited<ReturnType<typeof issueDeleteComment>>
>;

export type IssueDeleteCommentMutationError = AxiosError<
  ForbiddenResponse | InternalServerErrorResponse
>;

/**
 * @summary Delete a comment
 */
export const useIssueDeleteComment = <
  TError = AxiosError<ForbiddenResponse | InternalServerErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof issueDeleteComment>>,
      TError,
      { owner: string; repo: string; id: number },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof issueDeleteComment>>,
  TError,
  { owner: string; repo: string; id: number },
  TContext
> => {
  const mutationOptions = getIssueDeleteCommentMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Edit a comment
 */
export const issueEditComment = (
  owner: MaybeRef<string>,
  repo: MaybeRef<string>,
  id: MaybeRef<number>,
  editIssueCommentOption: MaybeRef<EditIssueCommentOption>,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<CommentResponse | EmptyResponse>> => {
  owner = unref(owner);
  repo = unref(repo);
  id = unref(id);
  editIssueCommentOption = unref(editIssueCommentOption);

  return axios.default.patch(
    `/repos/${owner}/${repo}/issues/comments/${id}`,
    editIssueCommentOption,
    options,
  );
};

export const getIssueEditCommentMutationOptions = <
  TError = AxiosError<
    | ForbiddenResponse
    | NotFoundResponse
    | RepoArchivedErrorResponse
    | InternalServerErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof issueEditComment>>,
    TError,
    { owner: string; repo: string; id: number; data: EditIssueCommentOption },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof issueEditComment>>,
  TError,
  { owner: string; repo: string; id: number; data: EditIssueCommentOption },
  TContext
> => {
  const mutationKey = ["issueEditComment"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof issueEditComment>>,
    { owner: string; repo: string; id: number; data: EditIssueCommentOption }
  > = (props) => {
    const { owner, repo, id, data } = props ?? {};

    return issueEditComment(owner, repo, id, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type IssueEditCommentMutationResult = NonNullable<
  Awaited<ReturnType<typeof issueEditComment>>
>;
export type IssueEditCommentMutationBody = EditIssueCommentOption;
export type IssueEditCommentMutationError = AxiosError<
  | ForbiddenResponse
  | NotFoundResponse
  | RepoArchivedErrorResponse
  | InternalServerErrorResponse
>;

/**
 * @summary Edit a comment
 */
export const useIssueEditComment = <
  TError = AxiosError<
    | ForbiddenResponse
    | NotFoundResponse
    | RepoArchivedErrorResponse
    | InternalServerErrorResponse
  >,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof issueEditComment>>,
      TError,
      { owner: string; repo: string; id: number; data: EditIssueCommentOption },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof issueEditComment>>,
  TError,
  { owner: string; repo: string; id: number; data: EditIssueCommentOption },
  TContext
> => {
  const mutationOptions = getIssueEditCommentMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary List comment's attachments
 */
export const issueListIssueCommentAttachments = (
  owner: MaybeRef<string>,
  repo: MaybeRef<string>,
  id: MaybeRef<number>,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<AttachmentListResponse>> => {
  owner = unref(owner);
  repo = unref(repo);
  id = unref(id);

  return axios.default.get(
    `/repos/${owner}/${repo}/issues/comments/${id}/assets`,
    options,
  );
};

export const getIssueListIssueCommentAttachmentsQueryKey = (
  owner?: MaybeRef<string>,
  repo?: MaybeRef<string>,
  id?: MaybeRef<number>,
) => {
  return ["repos", owner, repo, "issues", "comments", id, "assets"] as const;
};

export const getIssueListIssueCommentAttachmentsQueryOptions = <
  TData = Awaited<ReturnType<typeof issueListIssueCommentAttachments>>,
  TError = AxiosError<ErrorResponse>,
>(
  owner: MaybeRef<string>,
  repo: MaybeRef<string>,
  id: MaybeRef<number>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof issueListIssueCommentAttachments>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = getIssueListIssueCommentAttachmentsQueryKey(owner, repo, id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof issueListIssueCommentAttachments>>
  > = ({ signal }) =>
    issueListIssueCommentAttachments(owner, repo, id, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!(unref(owner) && unref(repo) && unref(id))),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof issueListIssueCommentAttachments>>,
    TError,
    TData
  >;
};

export type IssueListIssueCommentAttachmentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof issueListIssueCommentAttachments>>
>;
export type IssueListIssueCommentAttachmentsQueryError =
  AxiosError<ErrorResponse>;

/**
 * @summary List comment's attachments
 */

export function useIssueListIssueCommentAttachments<
  TData = Awaited<ReturnType<typeof issueListIssueCommentAttachments>>,
  TError = AxiosError<ErrorResponse>,
>(
  owner: MaybeRef<string>,
  repo: MaybeRef<string>,
  id: MaybeRef<number>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof issueListIssueCommentAttachments>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getIssueListIssueCommentAttachmentsQueryOptions(
    owner,
    repo,
    id,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData>;

  return query;
}

/**
 * @summary Create a comment attachment
 */
export const issueCreateIssueCommentAttachment = (
  owner: MaybeRef<string>,
  repo: MaybeRef<string>,
  id: MaybeRef<number>,
  issueCreateIssueCommentAttachmentBody: MaybeRef<IssueCreateIssueCommentAttachmentBody>,
  params?: MaybeRef<IssueCreateIssueCommentAttachmentParams>,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<AttachmentResponse>> => {
  owner = unref(owner);
  repo = unref(repo);
  id = unref(id);
  issueCreateIssueCommentAttachmentBody = unref(
    issueCreateIssueCommentAttachmentBody,
  );
  params = unref(params);
  const formData = new FormData();
  formData.append(
    `attachment`,
    issueCreateIssueCommentAttachmentBody.attachment,
  );

  return axios.default.post(
    `/repos/${owner}/${repo}/issues/comments/${id}/assets`,
    formData,
    {
      ...options,
      params: { ...unref(params), ...options?.params },
    },
  );
};

export const getIssueCreateIssueCommentAttachmentMutationOptions = <
  TError = AxiosError<
    | ErrorResponse
    | QuotaExceededResponse
    | ValidationErrorResponse
    | RepoArchivedErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof issueCreateIssueCommentAttachment>>,
    TError,
    {
      owner: string;
      repo: string;
      id: number;
      data: IssueCreateIssueCommentAttachmentBody;
      params?: IssueCreateIssueCommentAttachmentParams;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof issueCreateIssueCommentAttachment>>,
  TError,
  {
    owner: string;
    repo: string;
    id: number;
    data: IssueCreateIssueCommentAttachmentBody;
    params?: IssueCreateIssueCommentAttachmentParams;
  },
  TContext
> => {
  const mutationKey = ["issueCreateIssueCommentAttachment"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof issueCreateIssueCommentAttachment>>,
    {
      owner: string;
      repo: string;
      id: number;
      data: IssueCreateIssueCommentAttachmentBody;
      params?: IssueCreateIssueCommentAttachmentParams;
    }
  > = (props) => {
    const { owner, repo, id, data, params } = props ?? {};

    return issueCreateIssueCommentAttachment(
      owner,
      repo,
      id,
      data,
      params,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type IssueCreateIssueCommentAttachmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof issueCreateIssueCommentAttachment>>
>;
export type IssueCreateIssueCommentAttachmentMutationBody =
  IssueCreateIssueCommentAttachmentBody;
export type IssueCreateIssueCommentAttachmentMutationError = AxiosError<
  | ErrorResponse
  | QuotaExceededResponse
  | ValidationErrorResponse
  | RepoArchivedErrorResponse
>;

/**
 * @summary Create a comment attachment
 */
export const useIssueCreateIssueCommentAttachment = <
  TError = AxiosError<
    | ErrorResponse
    | QuotaExceededResponse
    | ValidationErrorResponse
    | RepoArchivedErrorResponse
  >,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof issueCreateIssueCommentAttachment>>,
      TError,
      {
        owner: string;
        repo: string;
        id: number;
        data: IssueCreateIssueCommentAttachmentBody;
        params?: IssueCreateIssueCommentAttachmentParams;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof issueCreateIssueCommentAttachment>>,
  TError,
  {
    owner: string;
    repo: string;
    id: number;
    data: IssueCreateIssueCommentAttachmentBody;
    params?: IssueCreateIssueCommentAttachmentParams;
  },
  TContext
> => {
  const mutationOptions =
    getIssueCreateIssueCommentAttachmentMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Get an issue
 */
export const issueGetIssue = (
  owner: MaybeRef<string>,
  repo: MaybeRef<string>,
  index: MaybeRef<number>,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<IssueResponse>> => {
  owner = unref(owner);
  repo = unref(repo);
  index = unref(index);

  return axios.default.get(`/repos/${owner}/${repo}/issues/${index}`, options);
};

export const getIssueGetIssueQueryKey = (
  owner?: MaybeRef<string>,
  repo?: MaybeRef<string>,
  index?: MaybeRef<number>,
) => {
  return ["repos", owner, repo, "issues", index] as const;
};

export const getIssueGetIssueQueryOptions = <
  TData = Awaited<ReturnType<typeof issueGetIssue>>,
  TError = AxiosError<NotFoundResponse>,
>(
  owner: MaybeRef<string>,
  repo: MaybeRef<string>,
  index: MaybeRef<number>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof issueGetIssue>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = getIssueGetIssueQueryKey(owner, repo, index);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof issueGetIssue>>> = ({
    signal,
  }) => issueGetIssue(owner, repo, index, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!(unref(owner) && unref(repo) && unref(index))),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof issueGetIssue>>,
    TError,
    TData
  >;
};

export type IssueGetIssueQueryResult = NonNullable<
  Awaited<ReturnType<typeof issueGetIssue>>
>;
export type IssueGetIssueQueryError = AxiosError<NotFoundResponse>;

/**
 * @summary Get an issue
 */

export function useIssueGetIssue<
  TData = Awaited<ReturnType<typeof issueGetIssue>>,
  TError = AxiosError<NotFoundResponse>,
>(
  owner: MaybeRef<string>,
  repo: MaybeRef<string>,
  index: MaybeRef<number>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof issueGetIssue>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getIssueGetIssueQueryOptions(
    owner,
    repo,
    index,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData>;

  return query;
}

/**
 * @summary Delete an issue
 */
export const issueDelete = (
  owner: MaybeRef<string>,
  repo: MaybeRef<string>,
  index: MaybeRef<number>,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<EmptyResponse>> => {
  owner = unref(owner);
  repo = unref(repo);
  index = unref(index);

  return axios.default.delete(
    `/repos/${owner}/${repo}/issues/${index}`,
    options,
  );
};

export const getIssueDeleteMutationOptions = <
  TError = AxiosError<ForbiddenResponse | NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof issueDelete>>,
    TError,
    { owner: string; repo: string; index: number },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof issueDelete>>,
  TError,
  { owner: string; repo: string; index: number },
  TContext
> => {
  const mutationKey = ["issueDelete"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof issueDelete>>,
    { owner: string; repo: string; index: number }
  > = (props) => {
    const { owner, repo, index } = props ?? {};

    return issueDelete(owner, repo, index, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type IssueDeleteMutationResult = NonNullable<
  Awaited<ReturnType<typeof issueDelete>>
>;

export type IssueDeleteMutationError = AxiosError<
  ForbiddenResponse | NotFoundResponse
>;

/**
 * @summary Delete an issue
 */
export const useIssueDelete = <
  TError = AxiosError<ForbiddenResponse | NotFoundResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof issueDelete>>,
      TError,
      { owner: string; repo: string; index: number },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof issueDelete>>,
  TError,
  { owner: string; repo: string; index: number },
  TContext
> => {
  const mutationOptions = getIssueDeleteMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Edit an issue. If using deadline only the date will be taken into account, and time of day ignored.
 */
export const issueEditIssue = (
  owner: MaybeRef<string>,
  repo: MaybeRef<string>,
  index: MaybeRef<number>,
  editIssueOption: MaybeRef<EditIssueOption>,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<IssueResponse>> => {
  owner = unref(owner);
  repo = unref(repo);
  index = unref(index);
  editIssueOption = unref(editIssueOption);

  return axios.default.patch(
    `/repos/${owner}/${repo}/issues/${index}`,
    editIssueOption,
    options,
  );
};

export const getIssueEditIssueMutationOptions = <
  TError = AxiosError<ForbiddenResponse | NotFoundResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof issueEditIssue>>,
    TError,
    { owner: string; repo: string; index: number; data: EditIssueOption },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof issueEditIssue>>,
  TError,
  { owner: string; repo: string; index: number; data: EditIssueOption },
  TContext
> => {
  const mutationKey = ["issueEditIssue"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof issueEditIssue>>,
    { owner: string; repo: string; index: number; data: EditIssueOption }
  > = (props) => {
    const { owner, repo, index, data } = props ?? {};

    return issueEditIssue(owner, repo, index, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type IssueEditIssueMutationResult = NonNullable<
  Awaited<ReturnType<typeof issueEditIssue>>
>;
export type IssueEditIssueMutationBody = EditIssueOption;
export type IssueEditIssueMutationError = AxiosError<
  ForbiddenResponse | NotFoundResponse | ErrorResponse
>;

/**
 * @summary Edit an issue. If using deadline only the date will be taken into account, and time of day ignored.
 */
export const useIssueEditIssue = <
  TError = AxiosError<ForbiddenResponse | NotFoundResponse | ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof issueEditIssue>>,
      TError,
      { owner: string; repo: string; index: number; data: EditIssueOption },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof issueEditIssue>>,
  TError,
  { owner: string; repo: string; index: number; data: EditIssueOption },
  TContext
> => {
  const mutationOptions = getIssueEditIssueMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary List all comments on an issue
 */
export const issueGetComments = (
  owner: MaybeRef<string>,
  repo: MaybeRef<string>,
  index: MaybeRef<number>,
  params?: MaybeRef<IssueGetCommentsParams>,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<CommentListResponse>> => {
  owner = unref(owner);
  repo = unref(repo);
  index = unref(index);
  params = unref(params);

  return axios.default.get(`/repos/${owner}/${repo}/issues/${index}/comments`, {
    ...options,
    params: { ...unref(params), ...options?.params },
  });
};

export const getIssueGetCommentsQueryKey = (
  owner?: MaybeRef<string>,
  repo?: MaybeRef<string>,
  index?: MaybeRef<number>,
  params?: MaybeRef<IssueGetCommentsParams>,
) => {
  return [
    "repos",
    owner,
    repo,
    "issues",
    index,
    "comments",
    ...(params ? [params] : []),
  ] as const;
};

export const getIssueGetCommentsQueryOptions = <
  TData = Awaited<ReturnType<typeof issueGetComments>>,
  TError = AxiosError<
    NotFoundResponse | ValidationErrorResponse | InternalServerErrorResponse
  >,
>(
  owner: MaybeRef<string>,
  repo: MaybeRef<string>,
  index: MaybeRef<number>,
  params?: MaybeRef<IssueGetCommentsParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof issueGetComments>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = getIssueGetCommentsQueryKey(owner, repo, index, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof issueGetComments>>
  > = ({ signal }) =>
    issueGetComments(owner, repo, index, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!(unref(owner) && unref(repo) && unref(index))),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof issueGetComments>>,
    TError,
    TData
  >;
};

export type IssueGetCommentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof issueGetComments>>
>;
export type IssueGetCommentsQueryError = AxiosError<
  NotFoundResponse | ValidationErrorResponse | InternalServerErrorResponse
>;

/**
 * @summary List all comments on an issue
 */

export function useIssueGetComments<
  TData = Awaited<ReturnType<typeof issueGetComments>>,
  TError = AxiosError<
    NotFoundResponse | ValidationErrorResponse | InternalServerErrorResponse
  >,
>(
  owner: MaybeRef<string>,
  repo: MaybeRef<string>,
  index: MaybeRef<number>,
  params?: MaybeRef<IssueGetCommentsParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof issueGetComments>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getIssueGetCommentsQueryOptions(
    owner,
    repo,
    index,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData>;

  return query;
}

/**
 * @summary Add a comment to an issue
 */
export const issueCreateComment = (
  owner: MaybeRef<string>,
  repo: MaybeRef<string>,
  index: MaybeRef<number>,
  createIssueCommentOption: MaybeRef<CreateIssueCommentOption>,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<CommentResponse>> => {
  owner = unref(owner);
  repo = unref(repo);
  index = unref(index);
  createIssueCommentOption = unref(createIssueCommentOption);

  return axios.default.post(
    `/repos/${owner}/${repo}/issues/${index}/comments`,
    createIssueCommentOption,
    options,
  );
};

export const getIssueCreateCommentMutationOptions = <
  TError = AxiosError<
    | ForbiddenResponse
    | NotFoundResponse
    | RepoArchivedErrorResponse
    | InternalServerErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof issueCreateComment>>,
    TError,
    {
      owner: string;
      repo: string;
      index: number;
      data: CreateIssueCommentOption;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof issueCreateComment>>,
  TError,
  {
    owner: string;
    repo: string;
    index: number;
    data: CreateIssueCommentOption;
  },
  TContext
> => {
  const mutationKey = ["issueCreateComment"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof issueCreateComment>>,
    {
      owner: string;
      repo: string;
      index: number;
      data: CreateIssueCommentOption;
    }
  > = (props) => {
    const { owner, repo, index, data } = props ?? {};

    return issueCreateComment(owner, repo, index, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type IssueCreateCommentMutationResult = NonNullable<
  Awaited<ReturnType<typeof issueCreateComment>>
>;
export type IssueCreateCommentMutationBody = CreateIssueCommentOption;
export type IssueCreateCommentMutationError = AxiosError<
  | ForbiddenResponse
  | NotFoundResponse
  | RepoArchivedErrorResponse
  | InternalServerErrorResponse
>;

/**
 * @summary Add a comment to an issue
 */
export const useIssueCreateComment = <
  TError = AxiosError<
    | ForbiddenResponse
    | NotFoundResponse
    | RepoArchivedErrorResponse
    | InternalServerErrorResponse
  >,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof issueCreateComment>>,
      TError,
      {
        owner: string;
        repo: string;
        index: number;
        data: CreateIssueCommentOption;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof issueCreateComment>>,
  TError,
  {
    owner: string;
    repo: string;
    index: number;
    data: CreateIssueCommentOption;
  },
  TContext
> => {
  const mutationOptions = getIssueCreateCommentMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Get an issue's labels
 */
export const issueGetLabels = (
  owner: MaybeRef<string>,
  repo: MaybeRef<string>,
  index: MaybeRef<number>,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<LabelListResponse>> => {
  owner = unref(owner);
  repo = unref(repo);
  index = unref(index);

  return axios.default.get(
    `/repos/${owner}/${repo}/issues/${index}/labels`,
    options,
  );
};

export const getIssueGetLabelsQueryKey = (
  owner?: MaybeRef<string>,
  repo?: MaybeRef<string>,
  index?: MaybeRef<number>,
) => {
  return ["repos", owner, repo, "issues", index, "labels"] as const;
};

export const getIssueGetLabelsQueryOptions = <
  TData = Awaited<ReturnType<typeof issueGetLabels>>,
  TError = AxiosError<NotFoundResponse>,
>(
  owner: MaybeRef<string>,
  repo: MaybeRef<string>,
  index: MaybeRef<number>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof issueGetLabels>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = getIssueGetLabelsQueryKey(owner, repo, index);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof issueGetLabels>>> = ({
    signal,
  }) => issueGetLabels(owner, repo, index, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!(unref(owner) && unref(repo) && unref(index))),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof issueGetLabels>>,
    TError,
    TData
  >;
};

export type IssueGetLabelsQueryResult = NonNullable<
  Awaited<ReturnType<typeof issueGetLabels>>
>;
export type IssueGetLabelsQueryError = AxiosError<NotFoundResponse>;

/**
 * @summary Get an issue's labels
 */

export function useIssueGetLabels<
  TData = Awaited<ReturnType<typeof issueGetLabels>>,
  TError = AxiosError<NotFoundResponse>,
>(
  owner: MaybeRef<string>,
  repo: MaybeRef<string>,
  index: MaybeRef<number>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof issueGetLabels>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getIssueGetLabelsQueryOptions(
    owner,
    repo,
    index,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData>;

  return query;
}

/**
 * @summary Replace an issue's labels
 */
export const issueReplaceLabels = (
  owner: MaybeRef<string>,
  repo: MaybeRef<string>,
  index: MaybeRef<number>,
  issueLabelsOptionBody: MaybeRef<IssueLabelsOptionBody>,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<LabelListResponse>> => {
  owner = unref(owner);
  repo = unref(repo);
  index = unref(index);
  issueLabelsOptionBody = unref(issueLabelsOptionBody);

  return axios.default.put(
    `/repos/${owner}/${repo}/issues/${index}/labels`,
    issueLabelsOptionBody,
    options,
  );
};

export const getIssueReplaceLabelsMutationOptions = <
  TError = AxiosError<ForbiddenResponse | NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof issueReplaceLabels>>,
    TError,
    { owner: string; repo: string; index: number; data: IssueLabelsOptionBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof issueReplaceLabels>>,
  TError,
  { owner: string; repo: string; index: number; data: IssueLabelsOptionBody },
  TContext
> => {
  const mutationKey = ["issueReplaceLabels"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof issueReplaceLabels>>,
    { owner: string; repo: string; index: number; data: IssueLabelsOptionBody }
  > = (props) => {
    const { owner, repo, index, data } = props ?? {};

    return issueReplaceLabels(owner, repo, index, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type IssueReplaceLabelsMutationResult = NonNullable<
  Awaited<ReturnType<typeof issueReplaceLabels>>
>;
export type IssueReplaceLabelsMutationBody = IssueLabelsOptionBody;
export type IssueReplaceLabelsMutationError = AxiosError<
  ForbiddenResponse | NotFoundResponse
>;

/**
 * @summary Replace an issue's labels
 */
export const useIssueReplaceLabels = <
  TError = AxiosError<ForbiddenResponse | NotFoundResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof issueReplaceLabels>>,
      TError,
      {
        owner: string;
        repo: string;
        index: number;
        data: IssueLabelsOptionBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof issueReplaceLabels>>,
  TError,
  { owner: string; repo: string; index: number; data: IssueLabelsOptionBody },
  TContext
> => {
  const mutationOptions = getIssueReplaceLabelsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Add a label to an issue
 */
export const issueAddLabel = (
  owner: MaybeRef<string>,
  repo: MaybeRef<string>,
  index: MaybeRef<number>,
  issueLabelsOptionBody: MaybeRef<IssueLabelsOptionBody>,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<LabelListResponse>> => {
  owner = unref(owner);
  repo = unref(repo);
  index = unref(index);
  issueLabelsOptionBody = unref(issueLabelsOptionBody);

  return axios.default.post(
    `/repos/${owner}/${repo}/issues/${index}/labels`,
    issueLabelsOptionBody,
    options,
  );
};

export const getIssueAddLabelMutationOptions = <
  TError = AxiosError<ForbiddenResponse | NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof issueAddLabel>>,
    TError,
    { owner: string; repo: string; index: number; data: IssueLabelsOptionBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof issueAddLabel>>,
  TError,
  { owner: string; repo: string; index: number; data: IssueLabelsOptionBody },
  TContext
> => {
  const mutationKey = ["issueAddLabel"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof issueAddLabel>>,
    { owner: string; repo: string; index: number; data: IssueLabelsOptionBody }
  > = (props) => {
    const { owner, repo, index, data } = props ?? {};

    return issueAddLabel(owner, repo, index, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type IssueAddLabelMutationResult = NonNullable<
  Awaited<ReturnType<typeof issueAddLabel>>
>;
export type IssueAddLabelMutationBody = IssueLabelsOptionBody;
export type IssueAddLabelMutationError = AxiosError<
  ForbiddenResponse | NotFoundResponse
>;

/**
 * @summary Add a label to an issue
 */
export const useIssueAddLabel = <
  TError = AxiosError<ForbiddenResponse | NotFoundResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof issueAddLabel>>,
      TError,
      {
        owner: string;
        repo: string;
        index: number;
        data: IssueLabelsOptionBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof issueAddLabel>>,
  TError,
  { owner: string; repo: string; index: number; data: IssueLabelsOptionBody },
  TContext
> => {
  const mutationOptions = getIssueAddLabelMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Remove all labels from an issue
 */
export const issueClearLabels = (
  owner: MaybeRef<string>,
  repo: MaybeRef<string>,
  index: MaybeRef<number>,
  deleteLabelsOption: MaybeRef<DeleteLabelsOption>,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<EmptyResponse>> => {
  owner = unref(owner);
  repo = unref(repo);
  index = unref(index);
  deleteLabelsOption = unref(deleteLabelsOption);

  return axios.default.delete(
    `/repos/${owner}/${repo}/issues/${index}/labels`,
    { data: deleteLabelsOption, ...options },
  );
};

export const getIssueClearLabelsMutationOptions = <
  TError = AxiosError<ForbiddenResponse | NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof issueClearLabels>>,
    TError,
    { owner: string; repo: string; index: number; data: DeleteLabelsOption },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof issueClearLabels>>,
  TError,
  { owner: string; repo: string; index: number; data: DeleteLabelsOption },
  TContext
> => {
  const mutationKey = ["issueClearLabels"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof issueClearLabels>>,
    { owner: string; repo: string; index: number; data: DeleteLabelsOption }
  > = (props) => {
    const { owner, repo, index, data } = props ?? {};

    return issueClearLabels(owner, repo, index, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type IssueClearLabelsMutationResult = NonNullable<
  Awaited<ReturnType<typeof issueClearLabels>>
>;
export type IssueClearLabelsMutationBody = DeleteLabelsOption;
export type IssueClearLabelsMutationError = AxiosError<
  ForbiddenResponse | NotFoundResponse
>;

/**
 * @summary Remove all labels from an issue
 */
export const useIssueClearLabels = <
  TError = AxiosError<ForbiddenResponse | NotFoundResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof issueClearLabels>>,
      TError,
      { owner: string; repo: string; index: number; data: DeleteLabelsOption },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof issueClearLabels>>,
  TError,
  { owner: string; repo: string; index: number; data: DeleteLabelsOption },
  TContext
> => {
  const mutationOptions = getIssueClearLabelsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary List all comments and events on an issue
 */
export const issueGetCommentsAndTimeline = (
  owner: MaybeRef<string>,
  repo: MaybeRef<string>,
  index: MaybeRef<number>,
  params?: MaybeRef<IssueGetCommentsAndTimelineParams>,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<TimelineListResponse>> => {
  owner = unref(owner);
  repo = unref(repo);
  index = unref(index);
  params = unref(params);

  return axios.default.get(`/repos/${owner}/${repo}/issues/${index}/timeline`, {
    ...options,
    params: { ...unref(params), ...options?.params },
  });
};

export const getIssueGetCommentsAndTimelineQueryKey = (
  owner?: MaybeRef<string>,
  repo?: MaybeRef<string>,
  index?: MaybeRef<number>,
  params?: MaybeRef<IssueGetCommentsAndTimelineParams>,
) => {
  return [
    "repos",
    owner,
    repo,
    "issues",
    index,
    "timeline",
    ...(params ? [params] : []),
  ] as const;
};

export const getIssueGetCommentsAndTimelineQueryOptions = <
  TData = Awaited<ReturnType<typeof issueGetCommentsAndTimeline>>,
  TError = AxiosError<
    NotFoundResponse | ValidationErrorResponse | InternalServerErrorResponse
  >,
>(
  owner: MaybeRef<string>,
  repo: MaybeRef<string>,
  index: MaybeRef<number>,
  params?: MaybeRef<IssueGetCommentsAndTimelineParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof issueGetCommentsAndTimeline>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = getIssueGetCommentsAndTimelineQueryKey(
    owner,
    repo,
    index,
    params,
  );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof issueGetCommentsAndTimeline>>
  > = ({ signal }) =>
    issueGetCommentsAndTimeline(owner, repo, index, params, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!(unref(owner) && unref(repo) && unref(index))),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof issueGetCommentsAndTimeline>>,
    TError,
    TData
  >;
};

export type IssueGetCommentsAndTimelineQueryResult = NonNullable<
  Awaited<ReturnType<typeof issueGetCommentsAndTimeline>>
>;
export type IssueGetCommentsAndTimelineQueryError = AxiosError<
  NotFoundResponse | ValidationErrorResponse | InternalServerErrorResponse
>;

/**
 * @summary List all comments and events on an issue
 */

export function useIssueGetCommentsAndTimeline<
  TData = Awaited<ReturnType<typeof issueGetCommentsAndTimeline>>,
  TError = AxiosError<
    NotFoundResponse | ValidationErrorResponse | InternalServerErrorResponse
  >,
>(
  owner: MaybeRef<string>,
  repo: MaybeRef<string>,
  index: MaybeRef<number>,
  params?: MaybeRef<IssueGetCommentsAndTimelineParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof issueGetCommentsAndTimeline>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getIssueGetCommentsAndTimelineQueryOptions(
    owner,
    repo,
    index,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData>;

  return query;
}

/**
 * @summary Get all of a repository's labels
 */
export const issueListLabels = (
  owner: MaybeRef<string>,
  repo: MaybeRef<string>,
  params?: MaybeRef<IssueListLabelsParams>,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<LabelListResponse>> => {
  owner = unref(owner);
  repo = unref(repo);
  params = unref(params);

  return axios.default.get(`/repos/${owner}/${repo}/labels`, {
    ...options,
    params: { ...unref(params), ...options?.params },
  });
};

export const getIssueListLabelsQueryKey = (
  owner?: MaybeRef<string>,
  repo?: MaybeRef<string>,
  params?: MaybeRef<IssueListLabelsParams>,
) => {
  return ["repos", owner, repo, "labels", ...(params ? [params] : [])] as const;
};

export const getIssueListLabelsQueryOptions = <
  TData = Awaited<ReturnType<typeof issueListLabels>>,
  TError = AxiosError<NotFoundResponse>,
>(
  owner: MaybeRef<string>,
  repo: MaybeRef<string>,
  params?: MaybeRef<IssueListLabelsParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof issueListLabels>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = getIssueListLabelsQueryKey(owner, repo, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof issueListLabels>>> = ({
    signal,
  }) => issueListLabels(owner, repo, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!(unref(owner) && unref(repo))),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof issueListLabels>>,
    TError,
    TData
  >;
};

export type IssueListLabelsQueryResult = NonNullable<
  Awaited<ReturnType<typeof issueListLabels>>
>;
export type IssueListLabelsQueryError = AxiosError<NotFoundResponse>;

/**
 * @summary Get all of a repository's labels
 */

export function useIssueListLabels<
  TData = Awaited<ReturnType<typeof issueListLabels>>,
  TError = AxiosError<NotFoundResponse>,
>(
  owner: MaybeRef<string>,
  repo: MaybeRef<string>,
  params?: MaybeRef<IssueListLabelsParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof issueListLabels>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getIssueListLabelsQueryOptions(
    owner,
    repo,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData>;

  return query;
}

/**
 * @summary Create a label
 */
export const issueCreateLabel = (
  owner: MaybeRef<string>,
  repo: MaybeRef<string>,
  createLabelOption: MaybeRef<CreateLabelOption>,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<LabelResponse>> => {
  owner = unref(owner);
  repo = unref(repo);
  createLabelOption = unref(createLabelOption);

  return axios.default.post(
    `/repos/${owner}/${repo}/labels`,
    createLabelOption,
    options,
  );
};

export const getIssueCreateLabelMutationOptions = <
  TError = AxiosError<NotFoundResponse | ValidationErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof issueCreateLabel>>,
    TError,
    { owner: string; repo: string; data: CreateLabelOption },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof issueCreateLabel>>,
  TError,
  { owner: string; repo: string; data: CreateLabelOption },
  TContext
> => {
  const mutationKey = ["issueCreateLabel"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof issueCreateLabel>>,
    { owner: string; repo: string; data: CreateLabelOption }
  > = (props) => {
    const { owner, repo, data } = props ?? {};

    return issueCreateLabel(owner, repo, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type IssueCreateLabelMutationResult = NonNullable<
  Awaited<ReturnType<typeof issueCreateLabel>>
>;
export type IssueCreateLabelMutationBody = CreateLabelOption;
export type IssueCreateLabelMutationError = AxiosError<
  NotFoundResponse | ValidationErrorResponse
>;

/**
 * @summary Create a label
 */
export const useIssueCreateLabel = <
  TError = AxiosError<NotFoundResponse | ValidationErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof issueCreateLabel>>,
      TError,
      { owner: string; repo: string; data: CreateLabelOption },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof issueCreateLabel>>,
  TError,
  { owner: string; repo: string; data: CreateLabelOption },
  TContext
> => {
  const mutationOptions = getIssueCreateLabelMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Get the authenticated user
 */
export const userGetCurrent = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<UserResponse>> => {
  return axios.default.get(`/user`, options);
};

export const getUserGetCurrentQueryKey = () => {
  return ["user"] as const;
};

export const getUserGetCurrentQueryOptions = <
  TData = Awaited<ReturnType<typeof userGetCurrent>>,
  TError = AxiosError<UnauthorizedResponse | ForbiddenResponse>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof userGetCurrent>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = getUserGetCurrentQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof userGetCurrent>>> = ({
    signal,
  }) => userGetCurrent({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof userGetCurrent>>,
    TError,
    TData
  >;
};

export type UserGetCurrentQueryResult = NonNullable<
  Awaited<ReturnType<typeof userGetCurrent>>
>;
export type UserGetCurrentQueryError = AxiosError<
  UnauthorizedResponse | ForbiddenResponse
>;

/**
 * @summary Get the authenticated user
 */

export function useUserGetCurrent<
  TData = Awaited<ReturnType<typeof userGetCurrent>>,
  TError = AxiosError<UnauthorizedResponse | ForbiddenResponse>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof userGetCurrent>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getUserGetCurrentQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData>;

  return query;
}

/**
 * @summary List the specified user's access tokens
 */
export const userGetTokens = (
  username: MaybeRef<string>,
  params?: MaybeRef<UserGetTokensParams>,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<AccessTokenListResponse>> => {
  username = unref(username);
  params = unref(params);

  return axios.default.get(`/users/${username}/tokens`, {
    ...options,
    params: { ...unref(params), ...options?.params },
  });
};

export const getUserGetTokensQueryKey = (
  username?: MaybeRef<string>,
  params?: MaybeRef<UserGetTokensParams>,
) => {
  return ["users", username, "tokens", ...(params ? [params] : [])] as const;
};

export const getUserGetTokensQueryOptions = <
  TData = Awaited<ReturnType<typeof userGetTokens>>,
  TError = AxiosError<ForbiddenResponse | NotFoundResponse>,
>(
  username: MaybeRef<string>,
  params?: MaybeRef<UserGetTokensParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof userGetTokens>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = getUserGetTokensQueryKey(username, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof userGetTokens>>> = ({
    signal,
  }) => userGetTokens(username, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(username)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof userGetTokens>>,
    TError,
    TData
  >;
};

export type UserGetTokensQueryResult = NonNullable<
  Awaited<ReturnType<typeof userGetTokens>>
>;
export type UserGetTokensQueryError = AxiosError<
  ForbiddenResponse | NotFoundResponse
>;

/**
 * @summary List the specified user's access tokens
 */

export function useUserGetTokens<
  TData = Awaited<ReturnType<typeof userGetTokens>>,
  TError = AxiosError<ForbiddenResponse | NotFoundResponse>,
>(
  username: MaybeRef<string>,
  params?: MaybeRef<UserGetTokensParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof userGetTokens>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getUserGetTokensQueryOptions(username, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData>;

  return query;
}

/**
 * @summary Generate an access token for the specified user
 */
export const userCreateToken = (
  username: MaybeRef<string>,
  createAccessTokenOption: MaybeRef<CreateAccessTokenOption>,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<AccessTokenResponse>> => {
  username = unref(username);
  createAccessTokenOption = unref(createAccessTokenOption);

  return axios.default.post(
    `/users/${username}/tokens`,
    createAccessTokenOption,
    options,
  );
};

export const getUserCreateTokenMutationOptions = <
  TError = AxiosError<ErrorResponse | ForbiddenResponse | NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof userCreateToken>>,
    TError,
    { username: string; data: CreateAccessTokenOption },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof userCreateToken>>,
  TError,
  { username: string; data: CreateAccessTokenOption },
  TContext
> => {
  const mutationKey = ["userCreateToken"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof userCreateToken>>,
    { username: string; data: CreateAccessTokenOption }
  > = (props) => {
    const { username, data } = props ?? {};

    return userCreateToken(username, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UserCreateTokenMutationResult = NonNullable<
  Awaited<ReturnType<typeof userCreateToken>>
>;
export type UserCreateTokenMutationBody = CreateAccessTokenOption;
export type UserCreateTokenMutationError = AxiosError<
  ErrorResponse | ForbiddenResponse | NotFoundResponse
>;

/**
 * @summary Generate an access token for the specified user
 */
export const useUserCreateToken = <
  TError = AxiosError<ErrorResponse | ForbiddenResponse | NotFoundResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof userCreateToken>>,
      TError,
      { username: string; data: CreateAccessTokenOption },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof userCreateToken>>,
  TError,
  { username: string; data: CreateAccessTokenOption },
  TContext
> => {
  const mutationOptions = getUserCreateTokenMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
